import { Injectable, Injector } from '@angular/core';
import { VirtualBackgroundPanelLocalStreamService } from './virtual-background-panel-local-stream.service';
import { VirtualBackgroundPanelBase } from './virtual-background-panel-base';

@Injectable()
export class VirtualBackgroundPanelService {
  private _service?: VirtualBackgroundPanelBase;

  constructor(private injector: Injector) {}

  getService() {
    // caching as the service will not change
    // once the panel opened
    if (this._service) {
      return this._service;
    }

    this._service = this.injector.get<VirtualBackgroundPanelBase>(
      VirtualBackgroundPanelLocalStreamService,
    );

    return this._service;
  }
}
